export const AuthorizationIds = {
    Roles: {
        SuperAdmin: '552edba2-c1f6-4067-b800-b1c5ac6690ae',   // Sistem yöneticisi (tüm firmalar üzerinde yetkili)
        CompanyAdmin: 'c229c8ec-83e5-4454-a409-07bce2f36ef5', // Şube sahibi / genel yönetici
        StoreManager: '354bab90-dd8d-4b37-8537-be4bc6f8c776', // Mağaza yöneticisi
        Salesperson: 'e234a812-35b5-4858-97f5-e034d704a987',  // Satış temsilcisi / personel
        Accountant: '2972f23f-13cd-4824-a8f2-9b517e8816a3'     // Muhasebe sorumlusu
    },
    List: [
        { name: 'Sistem Yöneticisi', id: '552edba2-c1f6-4067-b800-b1c5ac6690ae' },
        { name: 'Firma Yöneticisi', id: 'c229c8ec-83e5-4454-a409-07bce2f36ef5' },
        { name: 'Mağaza Yöneticisi', id: '354bab90-dd8d-4b37-8537-be4bc6f8c776' },
        { name: 'Satış Personeli', id: 'e234a812-35b5-4858-97f5-e034d704a987' },
        { name: 'Muhasebe Sorumlusu', id: '2972f23f-13cd-4824-a8f2-9b517e8816a3' }
    ]
}

export const GetHighestAuthOrder = (roles: string[]) => {
    var isSuperAdmin = roles.includes(AuthorizationIds.Roles.SuperAdmin);
    var isCompanyAdmin = roles.includes(AuthorizationIds.Roles.CompanyAdmin);
    var isStoreManager = roles.includes(AuthorizationIds.Roles.StoreManager);
    var isSalesPerson = roles.includes(AuthorizationIds.Roles.Salesperson);
    var isAccoutant = roles.includes(AuthorizationIds.Roles.Accountant);

    //! This code order is important
    if (isSuperAdmin) {
        return AuthorizationIds.Roles.SuperAdmin
    }
    if (isCompanyAdmin) {
        return AuthorizationIds.Roles.CompanyAdmin
    }
    if (isStoreManager) {
        return AuthorizationIds.Roles.StoreManager
    }
    if (isSalesPerson) {
        return AuthorizationIds.Roles.Salesperson
    }
    if (isAccoutant) {
        return AuthorizationIds.Roles.Accountant
    }

    //Else
    return AuthorizationIds.Roles.Salesperson
}
